export class ValidationError {
  constructor(
    readonly title: string,
    readonly message: string,
    readonly sender: string
  ) {}
}
